$(document).on('click', '.company-index-page .sp-head-filter-icons .btn-search', function (event) {
  event.preventDefault();

  const $button = $(this);
  const $filter = $button.closest('.company-index-page').find('.company-filter-area');
  const isHidden = $filter.hasClass('d-none');

  $filter.toggleClass('d-none', !isHidden);
  $button.attr('aria-expanded', isHidden ? 'true' : 'false');
});
